module.exports = __webpack_public_path__ + "static/img/VA.f57ca707.svg";